import { createAction, props } from '@ngrx/store';

export const AuthActions = {
  // Initiates the logout process
  // This should only be called when you explicitly want to destroy the session, not when the session is expired
  logoutRequested: createAction('[Auth] Logout Requested'),

  // Initiates ending impersonation only (without full logout)
  endImpersonationRequested: createAction('[Auth] End Impersonation Requested'),

  // Dispatched after all local cleanup is done
  logoutLocalCleanupCompleted: createAction('[Auth] Local Cleanup Completed'),

  // Dispatched after Okta logout is successful
  logoutOktaCompleted: createAction('[Auth] Okta Logout Completed'),

  // Dispatched after impersonation is ended successfully
  impersonationEnded: createAction('[Auth] Impersonation Ended'),

  // Dispatched if impersonation process fails
  impersonationFailed: createAction(
    '[Auth] Impersonation Failed',
    props<{ error: any }>(),
  ),

  // Dispatched if any part of the logout process fails
  logoutFailed: createAction('[Auth] Logout Failed', props<{ error: any }>()),

  // Final action to indicate complete logout success
  logoutCompleted: createAction('[Auth] Logout Process Completed'),

  // Login actions
  initializeLogin: createAction('[Auth] Initialize Login'),

  handleLoginRedirect: createAction('[Auth] Handle Login Redirect'),

  loginSuccess: createAction(
    '[Auth] Login Success',
    props<{ redirectUri?: string }>(),
  ),

  loginFailed: createAction('[Auth] Login Failed', props<{ error: any }>()),

  showOktaSignInWidget: createAction('[Auth] Show Okta SignIn Widget'),

  oktaWidgetRendered: createAction('[Auth] Okta Widget Rendered'),

  createOrUpdateUser: createAction(
    '[Auth] Create Or Update User',
    props<{ payload: any }>(),
  ),
};
